import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import EmberObject, { action, set } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import FollowingApi from 'mewe/api/following-api';
import { A } from '@ember/array';
import dispatcher from 'mewe/dispatcher';
import { later } from '@ember/runloop';

export default class MwSuggestedProfiles extends Component {

  @service dynamicDialogs;
  @service router;

  @tracked results = A();

  @action
  fetchSuggestions() {
    FollowingApi.suggestions().then((response) => {
      this.results = A(response.results.map((el) => {
        el.user.followedStatus = null;
        el.user.inProgress = false;
        el.user.hidden = false;
        return EmberObject.create(el.user);
      }));
    });
  }

  @action
  followUser(user, event) {
    event.stopPropagation();

    set(user, 'inProgress', true);

    dispatcher.dispatch('contact', 'followUser',
      { user,
        skipSuccessMessage: true,
        alwaysCb: () => {
          set(user, 'inProgress', false);
        },
      }
    );
  }

  @action
  unfollowUser(user, event) {
    event.stopPropagation();

    set(user, 'inProgress', true);

    const alwaysCb = () => {
      set(user, 'inProgress', false);
    };

    if (user.followRequestSent) {
      dispatcher.dispatch('contact', 'cancelRequestSent', { user }, null, alwaysCb);
    } else {
      dispatcher.dispatch('contact', 'unfollowUser', { user, alwaysCb });
    }
  }

  @action
  hideSuggestion(user, event) {
    event.stopPropagation();

    FollowingApi.hideSuggestion({ userId: user.id }).then(() => {
      set(user, 'hidden', true);
      // wait for the animation to complete
      later(() => this.results.removeObject(user), 150);
    });
  }

}
